
import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { supabase } from './lib/supabase'

// تحميل معلومات SEO في الخلفية (بدون انتظار)
const loadSEOSettings = async () => {
  try {
    const { data: seoSettings } = await supabase
      .from('site_settings')
      .select('*')
      .eq('setting_key', 'seo_settings')
      .maybeSingle();

    if (seoSettings?.setting_value) {
      const lang = localStorage.getItem('i18nextLng') || 'ar';
      const seo = seoSettings.setting_value;
      
      // تطبيق إعدادات SEO
      if (seo.meta_title) {
        const metaTitle = lang === 'ar' ? seo.meta_title.ar : seo.meta_title.en;
        if (metaTitle) document.title = metaTitle;
      }
      
      if (seo.meta_description) {
        const metaDesc = lang === 'ar' ? seo.meta_description.ar : seo.meta_description.en;
        if (metaDesc) {
          let metaDescTag = document.querySelector('meta[name="description"]');
          if (metaDescTag) {
            metaDescTag.setAttribute('content', metaDesc);
          }
        }
      }
      
      if (seo.meta_keywords) {
        const metaKeywords = lang === 'ar' ? seo.meta_keywords.ar : seo.meta_keywords.en;
        if (metaKeywords) {
          let metaKeywordsTag = document.querySelector('meta[name="keywords"]');
          if (metaKeywordsTag) {
            metaKeywordsTag.setAttribute('content', metaKeywords);
          }
        }
      }
      
      if (seo.canonical_url) {
        let canonicalTag = document.querySelector('link[rel="canonical"]');
        if (canonicalTag) {
          canonicalTag.setAttribute('href', seo.canonical_url);
        }
      }
      
      if (seo.geo_region) {
        let geoRegionTag = document.querySelector('meta[name="geo.region"]');
        if (geoRegionTag) {
          geoRegionTag.setAttribute('content', seo.geo_region);
        }
      }
      
      if (seo.geo_placename) {
        const geoPlace = lang === 'ar' ? seo.geo_placename.ar : seo.geo_placename.en;
        if (geoPlace) {
          let geoPlaceTag = document.querySelector('meta[name="geo.placename"]');
          if (geoPlaceTag) {
            geoPlaceTag.setAttribute('content', geoPlace);
          }
        }
      }
      
      if (seo.og_title) {
        const ogTitle = lang === 'ar' ? seo.og_title.ar : seo.og_title.en;
        if (ogTitle) {
          let ogTitleTag = document.querySelector('meta[property="og:title"]');
          if (ogTitleTag) {
            ogTitleTag.setAttribute('content', ogTitle);
          }
        }
      }
      
      if (seo.og_description) {
        const ogDesc = lang === 'ar' ? seo.og_description.ar : seo.og_description.en;
        if (ogDesc) {
          let ogDescTag = document.querySelector('meta[property="og:description"]');
          if (ogDescTag) {
            ogDescTag.setAttribute('content', ogDesc);
          }
        }
      }
    }
  } catch (error) {
    console.error('Error loading SEO settings:', error);
  }
};

// تحميل عنوان الموقع في الخلفية
const loadSiteTitle = async () => {
  try {
    const { data: siteInfoData } = await supabase
      .from('site_settings')
      .select('*')
      .eq('setting_key', 'site_info')
      .maybeSingle();

    if (siteInfoData?.setting_value) {
      const lang = localStorage.getItem('i18nextLng') || 'ar';
      const siteName = lang === 'ar' 
        ? siteInfoData.setting_value.site_name_ar 
        : siteInfoData.setting_value.site_name_en;
      
      if (siteName) {
        document.title = siteName;
      }
    }
  } catch (error) {
    console.error('Error loading site title:', error);
  }
};

// عرض التطبيق فوراً بدون انتظار
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// تحميل الإعدادات الإضافية في الخلفية
loadSiteTitle();
loadSEOSettings();
